import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=3c9c8784&"
var script = {}
import style0 from "./Layouts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports